// extracted by mini-css-extract-plugin
module.exports = {"grid_box":"grid_box___1kKWo","grid_item":"grid_item___3B6Ha","grid_btn":"grid_btn___3hwje"};